class AboutAccountDropdown extends HTMLElement {
  connectedCallback() {
    if (this.events) return;
    this.events = new AbortController();
    const options = { signal: this.events.signal };
    this.button = this.querySelector('button');
    this.panel = this.querySelector('[popover]');
    if (!this.button || !this.panel) return;
    this.panel.addEventListener('beforetoggle', (event) => {
      if (event.newState === 'open') this.position();
      this.button.setAttribute('aria-expanded', String(event.newState === 'open'));
    }, options);
    this.panel.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button === 0 && event.target.closest('a[href]')) event.preventDefault();
    }, options);
    this.panel.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!link || !this.panel.contains(link)) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
      event.preventDefault();
      event.stopPropagation();
      window.location.assign(link.href);
    }, options);
    window.addEventListener('resize', () => { if (this.panel.matches(':popover-open')) this.position(); }, options);
    document.addEventListener('scroll', (event) => {
      if (this.panel.matches(':popover-open') && !this.panel.contains(event.target)) this.position();
    }, { ...options, capture: true, passive: true });
    document.addEventListener('theme-drawer:open', () => this.close(), options);
    document.addEventListener('focusin', (event) => { if (!this.contains(event.target)) this.close(); }, options);
  }
  position() {
    const rect = this.button.getBoundingClientRect();
    const width = Math.min(300, document.documentElement.clientWidth - 24);
    const top = Math.min(rect.bottom - 1, window.innerHeight - 80);
    this.panel.style.top = top + 'px';
    this.panel.style.left = Math.max(12, Math.min(rect.right - width, document.documentElement.clientWidth - width - 12)) + 'px';
    this.panel.style.setProperty('--account-max-height', Math.max(60, window.innerHeight - top - 12) + 'px');
  }
  close() { if (this.panel?.matches(':popover-open')) this.panel.hidePopover(); }
  disconnectedCallback() { this.events?.abort(); this.events = null; }
}
if (!customElements.get('about-account-dropdown')) customElements.define('about-account-dropdown', AboutAccountDropdown);
